<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Maître de stage à agréer">
        <p class="text-sm-left body-2 font-italic">
          <b><u>Les informations ci-dessous doivent être exactes pour permettre
              votre accés à l'espace pédagogique dédié aux maîtres de stage</u></b>
        </p>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="8">
              <v-card class="mx-auto">
                <v-row>
                  <v-col cols="3">
                    <v-row>
                      <p><br /></p>
                    </v-row>
                    <v-row class="margin-left-15px">
                      <v-radio-group v-model="dossier.maitreCivilite" row required :rules="radioRules">
                        <v-radio label="Monsieur" name="maitreCivilite" v-bind:value="true" required></v-radio>
                        <v-radio label="Madame" name="maitreCivilite" v-bind:value="false" required></v-radio>
                      </v-radio-group>
                    </v-row>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field v-model="dossier.maitreNom" :rules="textRules" label="Nom usuel"
                      required></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field v-model="dossier.maitreNomNaissance" :rules="textRules" label="Nom de naissance"
                      required></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field v-model="dossier.maitrePrenom" :rules="textRules" label="Prénom (en toutes lettres)"
                      required></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="11" class="margin-left-15px">
                    <v-text-field v-model="dossier.maitreCourriel" :rules="emailRules" label="Adresse mail personnelle"
                      required></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="2" class="margin-left-15px margin-top-10px">
                    <span class="text-sm-left body-2">
                      Date de naissance :
                    </span>
                  </v-col>
                  <v-col cols="1">
                    <v-select :items="getJours()" label="jour" v-model="jourN" dense></v-select>
                  </v-col>
                  <v-col cols="1">
                    <v-select :items="getMois()" label="mois" v-model="moisN" dense></v-select>
                  </v-col>
                  <v-col cols="2">
                    <v-select :items="getAnnees()" label="annee" v-model="anneeN" dense></v-select>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <p><br /></p>
          </v-row>
          <v-row>
            <v-col cols="5">
              <v-text-field v-model="dossier.maitreAdresse" :rules="textRules" label="Adresse" required></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field v-model="dossier.maitreTel" :rules="telephoneRules" label="Téléphone"
                required></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <v-text-field v-model="dossier.maitreRPPS" :rules="rppsRules" label="Numéro RPPS" required></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-select v-model="dossier.maitreDiplomeDate" :items="getAnnees()" label="Année d’obtention du diplôme"
                :rules="obtentionDiplomeRules" required></v-select>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="dossier.maitreDiplomeUFR" :rules="textRules" label="UFR" required></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-select v-model="dossier.maitreAnneesExercice" :items="rangeNbAnneesExercice" :rules="nbAnneesRules"
                label="Nombre d’années d’exercice" required @change="setMaxNbAnneesTitulaire()"></v-select>
            </v-col>
            <v-col cols="4">
              <v-select v-model="dossier.maitreAnneesTitulaire" :items="rangeNbAnneesTitulaire" :rules="nbAnneesRules"
                label="Nombre d’années en tant que titulaire" required></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-row v-for="(diplomeAutre, index) in diplomesAutres" :key="index">
                <v-col cols="2">
                  <v-select v-model="diplomesAutres[index].annee" :items="getAnnees()"
                    label="Année d’obtention du diplôme" required></v-select>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="diplomesAutres[index].libelle"
                    :label="getAutreDiplomeLabel(index)"></v-text-field>
                </v-col>
              </v-row>
              <v-btn @click="diplomesAutres.push({ annee: '', libelle: '' })" :disabled="diplomesAutres.length > 4">+
                ajouter un autre diplôme universitaire</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="5">
              <v-text-field v-model="dossier.maitreResponsabilites"
                label="Responsabilités éventuelles dans le domaine pharmaceutique et de la santé*"></v-text-field>
              <p class="text-sm-left body-2 font-italic">
                * Exemples : professeur ou maître de conférences associé,
                conseiller ordinal, association de maîtres de stage, association
                de malades, réseaux de santé, actions de formation continue,
                syndicat etc.…
              </p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="5" />
            <v-col cols="1">
              <v-btn color="blue" class="mr-4 white--text" @click="submit" :disabled="!valid">Enregistrer et passer à
                l'étape suivante
                <v-icon>navigate_next</v-icon></v-btn>
            </v-col>
          </v-row>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import moment from "moment";
import common from "@/common";

export default {
  name: "Partie1",
  props: ["dossier"],
  data: () => ({
    maitreDateNaissance: null,
    jourN: null,
    moisN: null,
    anneeN: null,
    rangeNbAnneesExercice: [...Array(61).keys()],
    rangeNbAnneesTitulaire: [...Array(61).keys()],
    valid: true,
    menu: false,
    diplomesAutres: [],
    textRules: [v => !!v || "Ce champ est requis"],
    radioRules: [v => v !== null || "Ce champ est requis"],
    telephoneRules: [
      v => !!v || "Le numéro de téléphone est requis",
      v =>
        (v && v.length == 10) ||
        "Le numéro de téléphone doit être composé de 10 chiffres",
      v =>
        /^-?([0-9]\d*\.?\d*)$/.test(v) ||
        "Le numéro de téléphone doit être composé uniquement de chiffres"
    ],
    rppsRules: [
      v => !!v || "Le numéro RPPS est requis",
      v =>
        (v && v.length == 11) ||
        "Le numéro RPPS doit être composé de 11 chiffres",
      v =>
        /^-?([0-9]\d*\.?\d*)$/.test(v) ||
        "Le numéro RPPS doit être composé uniquement de chiffres"
    ],
    nbAnneesRules: [v => !!v || "Le nombre d'années est requis"],
    emailRules: [
      v => !!v || "Une adresse de courriel est requise",
      v => /.+@.+\..+/.test(v) || "L'adresse de courriel doit être valide"
    ],
    obtentionDiplomeRules: [
      v => !!v || "L'année d'obtention du diplôme est requise"
    ]
  }),
  components: { BaseBlock },
  computed: {},
  created() {
    this.diplomesAutres = JSON.parse(this.dossier.maitreAutresDiplomes);
    if (!this.diplomesAutres) this.diplomesAutres = [];
    if (this.dossier.maitreDateNaissance) {
      this.maitreDateNaissance = common.formatDate(
        this.dossier.maitreDateNaissance
      );
      this.jourN = this.maitreDateNaissance.split("/")[0];
      this.moisN = this.maitreDateNaissance.split("/")[1];
      this.anneeN = this.maitreDateNaissance.split("/")[2];
    }
  },
  methods: {
    getAnnees() {
      let currentYear = new Date().getFullYear();
      let years = [];
      let startYear = 1930;
      while (currentYear >= startYear) {
        years.push("" + currentYear--);
      }
      return years;
    },
    getMois() {
      return [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12"
      ];
    },
    getJours() {
      return [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31"
      ];
    },
    setMaxNbAnneesTitulaire() {
      this.rangeNbAnneesTitulaire = [
        ...Array(this.dossier.maitreAnneesExercice + 1).keys()
      ];
    },
    getAutreDiplomeLabel(index) {
      let part = index + 1;
      return "Autre diplôme universitaire (" + part + "/5)";
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.dossier.maitreDateNaissance = moment(
          this.anneeN + "-" + this.moisN + "-" + this.jourN
        ).format("YYYY-MM-DD");
        this.dossier.maitreAutresDiplomes = JSON.stringify(this.diplomesAutres);

        this.$emit("save");
        this.$emit("nextPart");
      }
    }
  }
};
</script>
<style>
div.margin-left-15px {
  margin-left: 15px;
}
</style>
